import { render, staticRenderFns } from "./CardsSection.vue?vue&type=template&id=29aa16e8"
import script from "./CardsSection.vue?vue&type=script&lang=js"
export * from "./CardsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports